export default "__VITE_ASSET__D7P6LJej__"